import React from 'react';
import { Link } from 'react-router-dom';
import { AiOutlineClose } from 'react-icons/ai';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { removeItem, incrementQuantity, decrementQuantity } from '../../redux/cartSlice';

const SideBarPanier = ({ isOpen, toggleSidebar }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const cart = useSelector((state) => state.cart);

  const subtotal = cart.reduce((total, item) => total + item.price * item.quantity, 0).toFixed(2);

  return (
    <div
      className="fixed inset-0 z-50"
      style={{
        opacity:    isOpen ? 1 : 0,
        visibility: isOpen ? 'visible' : 'hidden',
        transition: `opacity 0.3s ease-in-out, visibility 0s ${isOpen ? '0s' : '0.3s'}`,
      }}
    >
      {/* Overlay */}
      <div
        className="absolute inset-0"
        style={{ backgroundColor: 'rgba(23,18,13,0.6)', backdropFilter: 'blur(4px)' }}
        onClick={toggleSidebar}
      />

      {/* Panneau droit */}
      <div
        className="absolute right-0 top-0 bottom-0 w-full md:w-2/3 lg:w-2/5 flex flex-col"
        style={{
          backgroundColor: '#FBF7EF',
          transform:  isOpen ? 'translateX(0)' : 'translateX(100%)',
          transition: 'transform 0.35s cubic-bezier(0.4,0,0.2,1)',
          borderLeft: '1px solid rgba(120,90,40,0.15)',
        }}
      >
        {/* Header */}
        <div
          className="flex items-center justify-between px-6 py-5 border-b"
          style={{ borderColor: 'rgba(120,90,40,0.12)' }}
        >
          <div>
            <span className="text-xs font-semibold tracking-[0.3em] uppercase text-amber-800">
              {cart.length} article{cart.length !== 1 ? 's' : ''}
            </span>
            <h2 className="font-sans text-xl text-stone-900 mt-0.5">{t('cart.title')}</h2>
          </div>
          <button
            onClick={toggleSidebar}
            className="rounded-full p-2 transition-all hover:bg-stone-200"
            aria-label="Fermer"
          >
            <AiOutlineClose className="text-xl text-stone-700" />
          </button>
        </div>

        {/* Articles */}
        <div className="flex-1 overflow-y-auto px-6 py-4">
          {cart.length === 0 ? (
            <div className="flex flex-col items-center justify-center h-full text-center">
              <p className="font-nunito text-stone-500">{t('cart.empty')}</p>
              <button
                onClick={toggleSidebar}
                className="mt-4 font-sans text-sm tracking-wide border-b pb-0.5 transition-opacity hover:opacity-70"
                style={{ color: '#C8951F', borderColor: '#C8951F' }}
              >
                Continuer mes achats
              </button>
            </div>
          ) : (
            <div className="space-y-4">
              {cart.map((item, index) => (
                <div
                  key={index}
                  className="flex gap-4 p-4 bg-white rounded-2xl border"
                  style={{ borderColor: 'rgba(120,90,40,0.12)' }}
                >
                  {/* Image */}
                  <div
                    className="flex-shrink-0 w-16 h-20 rounded-xl flex items-center justify-center"
                    style={{ backgroundColor: '#F4ECDD' }}
                  >
                    <img src={item.image} alt={item.title} className="h-full w-auto object-contain p-1" />
                  </div>

                  {/* Infos */}
                  <div className="flex-1 min-w-0">
                    <h3 className="font-sans text-sm text-stone-900 line-clamp-2">{item.title}</h3>
                    <p className="font-sans text-base mt-1" style={{ color: '#A9760F' }}>
                      {item.price.toFixed(2)} €
                    </p>

                    {/* Quantite inline */}
                    <div className="flex items-center gap-2 mt-2">
                      <button
                        onClick={() => dispatch(decrementQuantity(item.id))}
                        className="w-7 h-7 rounded-full border flex items-center justify-center text-stone-600 hover:bg-stone-100 transition-colors"
                        style={{ borderColor: 'rgba(120,90,40,0.2)' }}
                      >
                        −
                      </button>
                      <span className="font-nunito text-sm w-6 text-center text-stone-800">{item.quantity}</span>
                      <button
                        onClick={() => dispatch(incrementQuantity(item.id))}
                        className="w-7 h-7 rounded-full border flex items-center justify-center text-stone-600 hover:bg-stone-100 transition-colors"
                        style={{ borderColor: 'rgba(120,90,40,0.2)' }}
                      >
                        +
                      </button>
                    </div>
                  </div>

                  {/* Total + supprimer */}
                  <div className="flex flex-col items-end justify-between flex-shrink-0">
                    <span className="font-sans text-sm text-stone-700">
                      {(item.price * item.quantity).toFixed(2)} €
                    </span>
                    <button
                      onClick={() => dispatch(removeItem(item.id))}
                      className="font-nunito text-xs text-stone-400 hover:text-red-500 transition-colors"
                    >
                      {t('cart.remove')}
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Footer avec sous-total + bouton */}
        {cart.length > 0 && (
          <div
            className="px-6 py-5 border-t"
            style={{ borderColor: 'rgba(120,90,40,0.12)', backgroundColor: '#F4ECDD' }}
          >
            <div className="flex items-center justify-between mb-4">
              <span className="font-nunito text-stone-600">{t('cart.subtotal')}</span>
              <span className="font-sans text-xl" style={{ color: '#A9760F' }}>{subtotal} €</span>
            </div>
            <Link to="/fullpanier" onClick={toggleSidebar}>
              <button
                className="w-full font-sans tracking-wide rounded-xl py-3.5 text-white transition-all duration-300 hover:opacity-90 hover:scale-[1.01]"
                style={{ backgroundColor: '#2E2318' }}
              >
                {t('cart.goToCart')}
              </button>
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default SideBarPanier;